import {
  PIN_HISTORIES_SUCCESS
} from '../actions/histories'

export default function (state = {}, action) {
  switch (action.type) {
    case PIN_HISTORIES_SUCCESS:
      return {
        ...state,
        [action.payload.pinId]: {
          ...state[action.payload.pinId],
          histories: action.payload.result
        }
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/pins.js